import React, { Fragment, Component } from 'react';
import { categoryData } from './CategoryDirectory';
export function Footer() {
  const navLinks = [{
    name: 'HOME',
    href: '/'
  }, {
    name: 'ABOUT US',
    href: '/about'
  }, {
    name: 'SHIPPING',
    href: '/shipping'
  }, {
    name: 'SITEMAP',
    href: '/ProductCatalogSitemap.html'
  }, {
    name: 'MODEL CHARTS',
    href: '/model-charts'
  }, {
    name: 'CAREERS',
    href: '/careers'
  }, {
    name: 'CONTACT',
    href: '/contact'
  }];
  // Split categories into two columns
  const midPoint = Math.ceil(categoryData.length / 2);
  const categoriesCol1 = categoryData.slice(0, midPoint);
  const categoriesCol2 = categoryData.slice(midPoint);
  return <footer className="bg-gray-900 text-white" data-id="element-239">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-240">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-241">
          {/* Company Info */}
          <div data-id="element-242">
            <a href="/" className="flex items-center gap-3 mb-4" data-id="element-243">
              <img src="https://cdn.magicpatterns.com/uploads/2wR3tqwkt4Sj9e5DsXEEta/USABB-icon-logo.png" alt="USA Bearings & Belts Logo" className="w-12 h-12 object-contain" data-id="element-244" />
              <div data-id="element-245">
                <div className="text-xl font-bold leading-tight" data-id="element-246">
                  <span className="text-red-500" data-id="element-247">USA</span>{' '}
                  <span className="text-white" data-id="element-248">Bearings & Belts</span>
                </div>
              </div>
            </a>
            <p className="text-gray-400 text-sm mb-4" data-id="element-249">
              Industrial Bearings, Belts, Chain, Sprockets & Power Transmission
              Components
            </p>
            <p className="text-gray-400 text-sm" data-id="element-250">
              Headquartered in Largo, Florida • Shipping Nationwide
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-251">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-252">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-253">
              {navLinks.map(link => <li key={link.name} data-id="element-254">
                  <a href={link.href} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-255">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Product Categories - All 11 in 2 columns */}
          <div data-id="element-256">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-257">
              Product Categories
            </h3>
            <div className="flex gap-8" data-id="element-258">
              <ul className="space-y-2" data-id="element-259">
                {categoriesCol1.map(group => <li key={group.title} data-id="element-260">
                    <a href="/ProductCatalogSitemap.html" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-261">
                      {group.title}
                    </a>
                  </li>)}
              </ul>
              <ul className="space-y-2" data-id="element-262">
                {categoriesCol2.map(group => <li key={group.title} data-id="element-263">
                    <a href="/ProductCatalogSitemap.html" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-264">
                      {group.title}
                    </a>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Contact Info - Moved to right side */}
          <div data-id="element-265">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-266">
              Contact Us
            </h3>
            <div className="space-y-3 text-sm" data-id="element-267">
              <p className="text-gray-300" data-id="element-268">
                <strong className="text-white" data-id="element-269">Commercial Sales Only:</strong>
                <br data-id="element-270" />
                <a href="tel:863-337-4984" className="text-xl font-bold text-white hover:text-red-400 transition-colors" data-id="element-271">
                  863-337-4984
                </a>
              </p>
              <p className="text-gray-300" data-id="element-272">
                <strong className="text-white" data-id="element-273">Hours:</strong>
                <br data-id="element-274" />
                M-Fri 9:00-3:00 ET
              </p>
              <p className="text-gray-300" data-id="element-275">
                <strong className="text-white" data-id="element-276">Email:</strong>
                <br data-id="element-277" />
                <a href="mailto:sales@usabearingsandbelts.com" className="text-blue-400 hover:text-blue-300" data-id="element-278">
                  sales@usabearingsandbelts.com
                </a>
              </p>
              <div className="pt-2 text-gray-400" data-id="element-279">
                <strong className="text-gray-300" data-id="element-280">Address:</strong>
                <br data-id="element-281" />
                8012 118th Ave N<br data-id="element-282" />
                Largo, Florida 33773
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <div className="border-t border-gray-800" data-id="element-283">
        <div className="max-w-7xl mx-auto px-4" data-id="element-284">
          <div className="flex items-center justify-center gap-1 py-4 flex-wrap" data-id="element-285">
            {navLinks.map((link, index, arr) => <Fragment key={link.name} data-id="element-286">
                <a href={link.href} className="text-gray-400 text-sm font-medium hover:text-white px-3" data-id="element-287">
                  {link.name}
                </a>
                {index < arr.length - 1 && <span className="text-gray-700" data-id="element-288">|</span>}
              </Fragment>)}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black border-t border-gray-800" data-id="element-289">
        <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-290">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500" data-id="element-291">
            <p data-id="element-292">
              © {new Date().getFullYear()} USA Bearings & Belts. All rights
              reserved.
            </p>
            <div className="flex items-center gap-4" data-id="element-293">
              <a href="/privacy" className="hover:text-white transition-colors" data-id="element-294">
                Privacy Policy
              </a>
              <span className="text-gray-700" data-id="element-295">|</span>
              <a href="/ProductCatalogSitemap.html" className="hover:text-white transition-colors" data-id="element-296">
                Site Map
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}